<!-- 供应商财务管理 -->
<template>
  <div class="container" :style="{ '--color': colors, '--bg': bacg }">
    <main class="main">
      <div class="tilte">
        <p>钱包</p>
        <p class="p1">常见问题?</p>
      </div>
      <div class="mainHeader">
        <div class="mainHeaderLeft">
          <div class="mainHeaderLeftImg"></div>
          <div class="mainHeaderLeftText">
            <p class="p1">机构可用余额</p>
            <p class="p2"><span>¥</span> {{ balanceObj.balance + balanceObj.lockBalance }}</p>
            <p class="p3">机构保证金账户</p>
            <p class="p4"><span>¥</span> 0</p>
          </div>
          <div class="mainHeaderLeftBtn">
            <div @click="handlerSelectClick(item)" v-for="(item, index) in btnList" :key="index" class="btns">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="center">
          <div class="centerBox" v-for="(item, index) in priceList" :key="index">
            <p class="p1"><span>¥</span> {{ item.key ? accumulateObj[item.key] : item.price }}</p>
            <p class="p2">{{ item.name }}</p>
          </div>
        </div>
        <div class="line"></div>
        <div class="right">
          <p class="p1"><span>现有积分：</span> 0</p>
          <p class="p1"><span>平台劵：</span> 0</p>
        </div>
      </div>
      <p class="mianCenterTitle">历史记录</p>
      <div class="mianCenterBtnBox">
        <div @click="handlerSwClick(item)" :class="balanceType === item.code ? 'mianCenterBtnsActive' : ''"
          class="mianCenterBtns" v-for="(item, index) in btnList1" :key="index">
          {{ item.name }}
        </div>
      </div>
      <div v-loading="loading">
        <transition name="el-zoom-in-center" mode="out-in">
          <reserveExpense @search="search" :tableData="viewDatas" v-if="balanceType == 1"></reserveExpense>
          <paymentDetails @search="search" :tableData="viewDatas" v-if="balanceType == 2"> </paymentDetails>
          <income :tableData="viewDatas" v-if="balanceType == 3"></income>
          <recharge :tableData="viewDatas" v-if="balanceType == 4"></recharge>
          <draw :tableData="viewDatas" v-if="balanceType == 5"></draw>
          <otherinCome :tableData="viewDatas" v-if="balanceType == 6"></otherinCome>
          <guarantee :tableData="viewDatas" v-if="balanceType == 7"></guarantee>
        </transition>
        <Pagination :pageSizes="pageSizes" @loadTable="update" :totalNumber="total"></Pagination>
      </div>
    </main>
    <rechargePopup @updatePrice="updatePrice" ref="rechargePopup"></rechargePopup>
    <drawingsPopup ref="drawingsPopup"></drawingsPopup>
    <makeMoneyPopup ref="makeMoneyPopup"></makeMoneyPopup>
    <payPopup ref="payPopup"></payPopup>
  </div>
</template>

<script>
import income from "./child/income.vue";
import recharge from "./child/recharge.vue";
import draw from "./child/draw.vue";
import otherinCome from "./child/otherinCome.vue";
import guarantee from "./child/guarantee.vue";
import rechargePopup from "./child/rechargePopup.vue";
import drawingsPopup from "./child/drawingsPopup.vue";
import makeMoneyPopup from "./child/makeMoneyPopup.vue";
import reserveExpense from "./child/reserveExpense.vue";
import payPopup from "./child/payPopup.vue";
import PayApi from '@/components/Api/pay.js'
import paymentDetails from "./child/paymentDetails.vue";
import Pagination from "@/components/Pagination.vue";
export default {
  components: {
    income,
    recharge,
    draw,
    otherinCome,
    guarantee,
    rechargePopup,
    drawingsPopup,
    makeMoneyPopup,
    reserveExpense,
    payPopup,
    Pagination,
    paymentDetails
  },
  data() {
    return {
      loading: false,
      balanceObj: {},//渲染的余额的数据
      pageSizes: [10, 20, 30, 40, 50],
      value: '',
      bacg: '#FBEFE8',
      colors: '#FF6637',
      headerList: ["我的账户", "积分", "平台劵", "积分商城"],
      btnList: ["充值", "提取", "挣钱", "缴费"],
      viewDatas: [],//渲染的表单数据
      total: 0,//表单渲染数目
      perPage: 1,
      pageSize: 10,
      filterCriteria: {
        balanceType: 1
      },//组件的筛选条件
      accumulateObj: {},//累计的金额的数据
      btnList1: [
        {
          name: '预定明细(支出)',
          code: 1
        },
        {
          name: '团组收款',
          code: 2
        },
        {
          name: '佣金结转明细',
          code: 3
        },
        {
          name: '充值明细',
          code: 4
        },
        {
          name: '提取明细',
          code: 5
        },
        {
          name: '其他收支出明细',
          code: 6
        },
        {
          name: '保证金账户明细',
          code: 7
        },
      ],
      priceList: [
        {
          name: "累计订单收入",
          price: 800,
          key: "orderPriceIncome",
        },
        {
          name: "累计订单支出",
          price: 800,
          key: "orderPricePay",
        },
        {
          name: "累计团组收款",
          price: 800,
          key: "planIncome",
        },
        {
          name: "累计充值",
          price: 0,
          key: "",
        },
        {
          name: "累计其他支出",
          price: 0,
          key: "",
        },
        {
          name: "累计其他收入",
          price: 0,
          key: "",
        },
        {
          name: "累计已提取金额",
          price: 0,
          key: "",
        },
      ],
      balanceType: 1,
    };
  },
  computed: {},
  watch: {},
  methods: {
    search(val) {
      this.viewDatas = []
      this.filterCriteria = val
      this.filterCriteria.balanceType = this.balanceType
      this.perPage = 1
      this.getDatas()
    },
    //按钮切换
    handlerSwClick(item) {
      this.balanceType = item.code
      this.filterCriteria = {
        balanceType: item.code
      }
      this.viewDatas = []
      this.total = 0
      this.perPage = 1
      if (this.balanceType == 7) {
        return
      }
      this.getDatas()
    },
    //更新table数据
    update(perPage, pageSize) {
      this.perPage = perPage
      this.pageSize = pageSize
      this.getDatas()
    },
    updatePrice() {
      this.getWalletTotal()
    },
    //获取钱包余额
    getWalletTotal() {
      new PayApi("pay",)
        .walletTotal({}, 'GET')
        .then((res) => {
          console.log(res, '看看接口返回的数据');
          if (res.status == 200) {
            this.balanceObj = res.data
          } else {
            this.$message.error(res.statusText);
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "系统异常!",
          });
        });
    },
    getAccumulatedAmount() {
      new PayApi("pay",)
        .balanceTotal()
        .then((res) => {
          console.log(res, '看看接口返回的数据');
          if (res.status == 200) {
            this.accumulateObj = res.data
          } else {
            this.$message.error(res.statusText);
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "系统异常!",
          });
        });
    },
    getDatas() {
      this.loading = true
      let data = {
        "page": this.perPage,
        "q": this.filterCriteria,
        "size": this.pageSize
      }
      new PayApi("pay",)
        .balanceList(data, 'GET')
        .then((res) => {
          console.log(res, '看看接口返回的数据');
          if (res.status == 200) {
            this.viewDatas = res.data.records
            this.total = res.data.total
            this.loading = false
          } else {
            this.$message.error(res.statusText);
            this.loading = false
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "系统异常!",
          });
        });
    },
    handlerSelectClick(item) {
      const map = {
        充值: () => (this.$refs.rechargePopup.initClick()),
        提取: () => (this.$refs.drawingsPopup.initClick(this.balanceObj)),
        挣钱: () => (this.$refs.makeMoneyPopup.dialogVisible = true),
        缴费: () => (this.$refs.payPopup.dialogVisible = true),
      };
      if (map[item]) {
        map[item]();
      } else {
      }
    },
  },
  created() { },
  mounted() {
    this.getWalletTotal()
    this.getDatas()
    this.getAccumulatedAmount()
  },
};
</script>
<style lang="scss" scoped>
.container {

  //  white-space: nowrap !important;
  .mianCenterBtnsActive {
    background-color: var(--color) !important;
    color: #fff !important;
  }

  .main {
    min-height: 7rem;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid #ebebeb;
    padding: 0.12rem 0.24rem;

    .tilte {
      display: flex;
      justify-content: space-between;
      font-size: 0.12rem;
      margin-bottom: 0.1rem;

      .p1 {
        color: #a3a3a3;
      }
    }

    .mainHeader {
      height: 1.1rem;
      background-color: #fafdfc;
      color: rgba(16, 16, 16, 1);
      font-family: Roboto;
      display: flex;
      align-items: center;
      margin-bottom: 0.24rem;

      .mainHeaderLeft {
        width: 4.6rem;
        height: 1.1rem;
        background-color: #f3f8f7;
        display: flex;
        align-items: center;
        margin-right: 0.24rem;
        padding-right: 0.12rem;

        .mainHeaderLeftImg {
          width: 0.88rem;
          height: 0.88rem;
          background-color: #dc6d33;
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-right: 0.24rem;
        }

        .mainHeaderLeftText {
          text-align: right;
          margin-right: 0.24rem;

          .p1 {
            color: rgba(57, 72, 87, 0.86);
            font-size: 0.1rem;
            font-family: SourceHanSansSC-regular;
          }

          .p2 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.22rem;
            font-family: SourceHanSansSC-bold;
            font-weight: bold;

            span {
              color: rgba(16, 16, 16, 1);
              font-size: 0.1rem;
              font-family: SourceHanSansSC-regular;
            }
          }

          .p3 {
            color: rgba(57, 72, 87, 0.86);
            font-size: 0.12rem;
            font-family: SourceHanSansSC-regular;
          }

          .p4 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.12rem;
            font-family: SourceHanSansSC-light;

            span {
              color: rgba(16, 16, 16, 1);
              font-size: 0.12rem;
              font-family: SourceHanSansSC-regular;
            }
          }
        }

        .mainHeaderLeftBtn {
          width: 1.4rem;
          height: 0.88rem;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-between;

          .btns {
            width: 0.63rem;
            height: 0.25rem;
            line-height: 0.25rem;
            border-radius: 0.05rem;
            background-color: rgba(255, 255, 255, 1);
            color: rgba(0, 132, 137, 1);
            font-size: 0.14rem;
            text-align: center;
            font-family: Roboto;
            cursor: pointer;
          }
        }
      }

      .center {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .centerBox {
          display: flex;
          align-items: center;
          flex-direction: column;

          .p1 {
            left: 494px;
            color: rgba(16, 16, 16, 1);
            font-size: 0.22rem;
            font-family: SourceHanSansSC-bold;

            span {
              color: rgba(16, 16, 16, 1);
              font-size: 0.1rem;
              font-family: SourceHanSansSC-regular;
            }
          }

          .p2 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.14rem;
            font-family: SourceHanSansSC-regular;
          }
        }
      }

      .line {
        height: 0.88rem;
        border-right: 1px solid #edefee;
        margin: 0 0.24rem;
      }

      .right {
        .p1 {
          color: rgba(57, 72, 87, 0.86);
          font-size: 0.22rem;
          font-family: SourceHanSansSC-bold;
          font-weight: bold;

          span {
            color: rgba(57, 72, 87, 0.86);
            font-size: 0.14rem;
            font-family: SourceHanSansSC-light;
            font-weight: 400;
            width: 1rem;
            display: inline-block;
          }
        }
      }
    }

    .mianCenterTitle {
      color: rgba(16, 16, 16, 1);
      font-size: 0.12rem;
      font-family: SourceHanSansSC-regular;
      margin-bottom: 0.1rem;
    }

    .mianCenterBtnBox {
      display: flex;
      align-items: center;
      margin-bottom: 0.24rem;

      .mianCenterBtns {
        margin-right: 0.15rem;
        padding: 0 0.1rem;
        height: 0.3rem;
        line-height: 0.3rem;
        border-radius: 0.05rem;
        background-color: #fff;
        color: var(--color);
        font-size: 0.14rem;
        text-align: center;
        font-family: Roboto;
        border: 1px solid var(--color);
        cursor: pointer;
      }
    }
  }
}
</style>
